

import { createGlobalState } from '@vueuse/core'
import { useEntity } from './useEntity'

export const useDataservice = createGlobalState(() => {

  const customerId = ref('')
  const isInited = ref(false)
  const setCustomerId = (id: string) => {
    customerId.value = id
  }

 

  // MS SQL
  const _users = shallowRef<ReturnType<typeof useEntity>>(null as any)
  const _userCurrent = shallowRef<ReturnType<typeof useEntity>>(null as any)
  const _userChangePassword = shallowRef<ReturnType<typeof useEntity>>(null as any)
  const _catalogs = shallowRef<ReturnType<typeof useEntity>>(null as any)
  const _customers = shallowRef<ReturnType<typeof useEntity>>(null as any)
  const _items = shallowRef<ReturnType<typeof useEntity>>(null as any)
  const _subItems = shallowRef<ReturnType<typeof useEntity>>(null as any)
  const _employees = shallowRef<ReturnType<typeof useEntity>>(null as any)
  const _settings = shallowRef<ReturnType<typeof useEntity>>(null as any)
  const _toppingItems = shallowRef<ReturnType<typeof useEntity>>(null as any)
  const _toppingGroups = shallowRef<ReturnType<typeof useEntity>>(null as any)
  const _comments = shallowRef<ReturnType<typeof useEntity>>(null as any)
  const _itemTags = shallowRef<ReturnType<typeof useEntity>>(null as any)
  const _orders = shallowRef<ReturnType<typeof useEntity>>(null as any)
  const _expenseGroups = shallowRef<ReturnType<typeof useEntity>>(null as any)
  const _expenseItems = shallowRef<ReturnType<typeof useEntity>>(null as any)
  const _expenseTransaction = shallowRef<ReturnType<typeof useEntity>>(null as any)
  const _systemEnv = shallowRef<ReturnType<typeof useEntity>>(null as any)

  //dynamo
  const _settingsDynamo = shallowRef<ReturnType<typeof useEntity>>(null as any)
  const _stockEmployeesPin = shallowRef<ReturnType<typeof useEntity>>(null as any)
  const _paymentType = shallowRef<ReturnType<typeof useEntity>>(null as any)
  const _productComboSet = shallowRef<ReturnType<typeof useEntity>>(null as any)

  // Stock API endpoints - **for report**
  const _stock = shallowRef<{
    list: ReturnType<typeof useEntity>
    balance: ReturnType<typeof useEntity>
    summary: ReturnType<typeof useEntity>
    individual: ReturnType<typeof useEntity>
    transactions: ReturnType<typeof useEntity>
  }>(null as any)

  const _receipts = shallowRef<ReturnType<typeof useEntity>>(null as any)

  // DynamoDB generic resources
  const _trackSetPriceAndDiscount = shallowRef<ReturnType<typeof useEntity>>(null as any)
  const _openMenu = shallowRef<ReturnType<typeof useEntity>>(null as any)
  const _voidItems = shallowRef<ReturnType<typeof useEntity>>(null as any)
  const _activities = shallowRef<ReturnType<typeof useEntity>>(null as any)
  const _stockItems = shallowRef<ReturnType<typeof useEntity>>(null as any)
  const _stockFormula = shallowRef<ReturnType<typeof useEntity>>(null as any)
  const _toppingFormula = shallowRef<ReturnType<typeof useEntity>>(null as any)

  // Reports (POST-only endpoints)
  const _receiptsSummary = shallowRef<ReturnType<typeof useEntity>>(null as any)
  const _receiptsDaily = shallowRef<ReturnType<typeof useEntity>>(null as any)
  const _productsSummary = shallowRef<ReturnType<typeof useEntity>>(null as any)
  const _productsDaily = shallowRef<ReturnType<typeof useEntity>>(null as any)

  //Email Daily
  const _emailDaily = shallowRef<ReturnType<typeof useEntity>>(null as any)

  //SMS
  const _sms = shallowRef<ReturnType<typeof useEntity>>(null as any)

  //Customer Emails (report recipients)
  const _customerEmails = shallowRef<ReturnType<typeof useEntity>>(null as any)

  // Migrate
  const _migrateStockTransactions = shallowRef<ReturnType<typeof useEntity>>(null as any)

  const businessModeResolver = () => useSettingsStore().getSystemEnvByName('BusinessMode')?.Value || '0'

  const init = () => {
    if (isInited.value) return
    isInited.value = true

    // MS SQL
    _users.value = useEntity('users', '/users')
    _userCurrent.value  = useEntity('users', '/users/current-user')
    _userChangePassword.value = useEntity('userChangePassword', '/users')
    _catalogs.value = useEntity('catalogs', '/catalogs')
    _customers.value = useEntity('customers', '/customers')
    _items.value = useEntity('items', '/items')
    _subItems.value = useEntity('subItems', '/subitems')
    _employees.value = useEntity('employees', '/employees')
    _settings.value = useEntity('settings', '/system-environments')
    _toppingItems.value = useEntity('toppings', '/toppings')
    _toppingGroups.value = useEntity('toppingGroups', '/topping-groups')
    _comments.value = useEntity('comments', '/comments')
    _itemTags.value = useEntity('itemTags', '/item-tags')
    _orders.value = useEntity('orders', '/orders')
    _expenseGroups.value = useEntity('expenseGroups', '/expense-groups')
    _expenseItems.value = useEntity('expenseItems', '/expense-items')
    _expenseTransaction.value = useEntity('expenseTransaction', '/expense-transactions')
    _systemEnv.value = useEntity('systemEnv', '/system-environments')

    //dynamo
    _settingsDynamo.value = useEntity('settingsDynamo', `/dynamodb/settings/${customerId.value}`)
    _stockEmployeesPin.value = useEntity('stockEmployeesPin', `/dynamodb/v1-employee-pin/${customerId.value}`)
    _paymentType.value = useEntity('paymentType', `/dynamodb/payment-types/${customerId.value}`)
    _productComboSet.value = useEntity('productComboSet', `/dynamodb/product-set/${customerId.value}`)

    // Stock API endpoints
    _stock.value = {
      list: useEntity('stockList', '/stock/list'),
      balance: useEntity('stockBalance', '/stock/balance'),
      summary: useEntity('stockSummary', '/stock/summary'),
      individual: useEntity('stockIndividual', '/stock/individual'),
      transactions: useEntity('stockTransactions', '/stock/transactions'),
    }

    _receipts.value = useEntity(
      'receipts',
      `/receipts/${customerId.value}`,
      { businessMode: businessModeResolver }
    )

    // DynamoDB generic resources
    _trackSetPriceAndDiscount.value = useEntity('trackSetPriceAndDiscount', `/dynamodb/track-set-price-and-discount/${customerId.value}`, { businessMode: businessModeResolver })
    _openMenu.value = useEntity('openMenu', `/dynamodb/open-menu/${customerId.value}`, { businessMode: businessModeResolver })
    _voidItems.value = useEntity('voidItems', `/dynamodb/void-items/${customerId.value}`, { businessMode: businessModeResolver })
    _activities.value = useEntity('activities', `/dynamodb/activities`)
    _stockItems.value = useEntity('stockItems', `/dynamodb/stock-items/${customerId.value}`)
    _stockFormula.value = useEntity('stockFormula', `/dynamodb/stock-formula/${customerId.value}`)
    _toppingFormula.value = useEntity('toppingFormula', `/dynamodb/topping-formula/${customerId.value}`)

    // Reports (POST-only endpoints)
    _receiptsSummary.value = useEntity('receiptsSummary', '/reports/receipts-summary', { businessMode: businessModeResolver })
    _receiptsDaily.value = useEntity('receiptsDaily', '/reports/receipts-daily', { businessMode: businessModeResolver })
    _productsSummary.value = useEntity('productsSummary', '/reports/products-summary', { businessMode: businessModeResolver })
    _productsDaily.value = useEntity('productsDaily', '/reports/products-daily', { businessMode: businessModeResolver })

    //Email Daily
    _emailDaily.value = useEntity('emailDaily', '/emails/email-daily', { businessMode: businessModeResolver })

    //SMS
    _sms.value = useEntity('sms', '/sms', { businessMode: businessModeResolver })

    //Customer Emails
    _customerEmails.value = useEntity('customerEmails', '/customer-emails')

    // Migrate
    _migrateStockTransactions.value = useEntity('migrateStockTransactions', '/migrate/stock-transactions')
  }

  return {
    customerId,
    isInited,
    setCustomerId,
    init,

    get stock() { return _stock.value },
    get stockEmployeesPin() { return _stockEmployeesPin.value },
    get paymentType() { return _paymentType.value },
    get productComboSet() { return _productComboSet.value },

    get customers() { return _customers.value },
    get userCurrent() { return _userCurrent.value },
    
    // Stock API endpoints
    get catalogs() { return _catalogs.value },
    get items() { return _items.value },
    get subItems() { return _subItems.value },
    get employees() { return _employees.value },
    get settings() { return _settings.value },
    get toppingItems() { return _toppingItems.value },
    get toppingGroups() { return _toppingGroups.value },
    get comments() { return _comments.value },
    get itemTags() { return _itemTags.value },
    get orders() { return _orders.value },
    get users() { return _users.value },
    get userChangePassword() { return _userChangePassword.value },
    get systemEnv() { return _systemEnv.value },

    get expenseGroups() { return _expenseGroups.value },
    get expenseItems() { return _expenseItems.value },
    get expenseTransaction() { return _expenseTransaction.value },
    get receipts() { return _receipts.value },

    // DynamoDB generic resources
    get trackSetPriceAndDiscount() { return _trackSetPriceAndDiscount.value },
    get openMenu() { return _openMenu.value },
    get voidItems() { return _voidItems.value },
    get activities() { return _activities.value },
    get settingsDynamo() { return _settingsDynamo.value },
    get stockFormula() { return _stockFormula.value },
    get toppingFormula() { return _toppingFormula.value },
    get stockItems() { return _stockItems.value },

    // Reports
    get receiptsSummary() { return _receiptsSummary.value },
    get receiptsDaily() { return _receiptsDaily.value },
    get productsSummary() { return _productsSummary.value },
    get productsDaily() { return _productsDaily.value },

    //Email Daily
    get emailDaily() { return _emailDaily.value },

    //SMS
    get sms() { return _sms.value },

    //Customer Emails
    get customerEmails() { return _customerEmails.value },

    // Migrate
    get migrateStockTransactions() { return _migrateStockTransactions.value },
  }
})
